<template>
  <section>
    <div class="container-fluid loginArea">
      <div class="row">
        <div class="col-sm-11 ml-sm-auto">
          <div class="loginScreen">
            <img src="../../../public/src/images/tcdd-logo.png" class="img-fluid tcddLogo" alt="tcdd-logo" />
            <h1>Yolcu Taşıma Platformu</h1>
            <form action="">
              <label class="loginLabel">{{ shouldUserChooseUnit ? "Lütfen biriminizi seçiniz" : "Lütfen hesabınıza giriş yapınız." }}</label>

              <div class="loginInput unitSelectArea">
                <template v-if="shouldUserChooseUnit">
                  <multi-select-wrapper
                    v-model="selectedUserUnitId"
                    :options="userUnits"
                    :required-star="true"
                    :rules="{ required: true }"
                    :label-text="'Birim Seçimi'"
                    :text-field="'name'"
                    :value-field="'id'"
                    :clean-option="false"
                    :allow-empty="false"
                    :searchable="true"
                    :internal-search="true"
                  />
                </template>
                <template v-else>
                  <input v-model="username" class="form-control" type="text" required aria-label="userNameInput" @keyup.enter="login()" />
                  <span class="floating-label">Kullanıcı adınız</span>
                </template>
              </div>

              <div v-if="!shouldUserChooseUnit" class="loginInput">
                <input v-model="password" class="form-control" :type="passwordType" required aria-label="passwordInput" @keyup.enter="login()" />
                <span class="floating-label">Şifreniz</span>
                <img
                  v-if="passwordType === 'password'"
                  src="../../../public/src/images/icon-feather-eye.svg"
                  class="passwordImg"
                  alt="icon-feather-eye"
                  @click="passwordShow('password')"
                />
                <img
                  v-if="passwordType === 'text'"
                  src="../../../public/src/images/icon-feather-eye-off.svg"
                  class="passwordImg"
                  alt="icon-feather-eye-off"
                  @click="passwordShow('text')"
                />
              </div>

              <div v-if="!shouldUserChooseUnit" class="form-group mb-0">
                <div class="form-check p-0">
                  <div class="row justify-content-between">
                    <div class="col-auto">
                      <base-check-box v-model="rememberMe" :text="'Beni Hatırla'" :checked="rememberMe" />
                    </div>
                    <div class="col-auto">
                      <button type="button" class="btn forgotPassword border-0 shadow-none p-0" data-toggle="modal" data-target="#passwordResetModal">
                        Şifremi Unuttum
                      </button>
                      <!--<a href="#" class="forgotPassword">Şifremi Unuttum</a>-->
                    </div>
                  </div>
                </div>
              </div>
              <div class="row customRow15">
                <div v-if="shouldUserChooseUnit" class="col-auto customPadding15">
                  <base-button
                    :btn-text="'Çıkış Yap'"
                    :btn-class="'secondary mb-3'"
                    :btn-disabled="loadingContinueButton"
                    :spinner="loadingContinueButton"
                    @click.native="resetUnitUser()"
                  />
                </div>
                <div v-if="shouldUserChooseUnit" class="col-auto customPadding15">
                  <base-button
                    :btn-text="'Devam Et'"
                    :btn-class="'primary mb-3'"
                    :btn-disabled="loadingContinueButton"
                    :spinner="loadingContinueButton"
                    @click.native="goToSalesTransactions()"
                  />
                </div>
                <div v-if="!shouldUserChooseUnit" class="col-auto customPadding15">
                  <base-button :btn-text="'Giriş yap'" :btn-class="'primary mr-0 mb-3'" :btn-disabled="loading" :spinner="loading" @click.native="login()" />
                </div>
              </div>

              <!--              <base-button :btn-text="'Kayıt Ol'" :btn-class="'primary'" :btn-outline="true"></base-button>-->

              <!--              <div class="form-group" v-if="!shouldUserChooseUnit">-->
              <!--                <label class="loginLabel">-->
              <!--                  veya giriş yap-->
              <!--                  <span>-->
              <!--                    <img :src="imgCdnUrl + 'images/icon-login-arrow.svg'" alt="icon-login-arrow" />-->
              <!--                  </span>-->
              <!--                </label>-->
              <!--                <div class="socialLogin row justify-content-between">-->
              <!--                  <a href="#" class="col-auto">Facebook</a>-->
              <!--                  <a href="#" class="col-auto">Linkedin</a>-->
              <!--                  <a href="#" class="col-auto">Google</a>-->
              <!--                </div>-->
              <!--              </div>-->
            </form>
          </div>
        </div>
      </div>
    </div>
    <base-alert />

    <!-- Delete Modal -->
    <div id="passwordResetModal" class="modal fade modalDelete" tabindex="-1" aria-labelledby="passwordResetModal" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12 mt-sm-3">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"><img src="../../../public/src/images/icon-modal-close.svg" alt="icon-modal-close" /></span>
                  </button>
                </div>
                <div class="col-12 text-center">
                  <img src="../../../public/src/images/icon-modal-question.svg" alt="icon-modal-question" />
                  <h3 class="modal-title mt-2">Uyarı</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <p class="text-center">Şifrenizi yenilemek üzere TCDD Taşımacılık A.Ş. Parola Yenileme Uygulaması'na yönlendiriliyorsunuz.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer mb-4">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12 text-center">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Hayır</button>
                  <button type="button" class="btn btn-primary" data-dismiss="modal" @click="requestPasswordReset()">Git</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- modal start -->
    <div
      id="modalRezervation"
      class="modal fade righToLeftModal ticketTypeModal ticketRezervationModal"
      tabindex="-1"
      aria-labelledby="modalRezervation"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <img src="../../../public/src/images/icon-user-white.svg" class="img-fluid" alt="icon-ticket-black" />
              Şifremi Unuttum
            </h5>
            <button type="button" class="close closebtn" aria-label="Close" data-toggle="modal" data-target="#modalRezervation">
              <span aria-hidden="true">
                <img src="../../../public/src/images/sidebar-menu-close.svg" alt="sidebar-menu-close" />
              </span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <section class="passwordResetModalBody">
                  <p class="textP">Lütfen şifre yenileme için gerekli bilgilerin gönderileceği e-posta adresini giriniz.</p>
                  <div class="form-group">
                    <label class="modalLabel">Sicil No:</label>
                    <input v-model="resetEnrollmentNo" aria-label="resetEnrollmentNoInput" class="form-control modalInput" type="text" />
                  </div>
                </section>
              </div>
            </div>
          </div>
          <div class="modal-footer d-block">
            <div class="row no-gutters">
              <div class="col-6 customP">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">İPTAL</button>
              </div>
              <div class="col-6 customP">
                <base-button
                  :btn-text="'Gönder'"
                  :btn-type="'button'"
                  :spinner="loadingResetPassword"
                  :btn-disabled="loadingResetPassword"
                  @click.native="resetPassword"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BaseButton from "../../component/element/buttons/BaseButton";
import BaseCheckBox from "../../component/element/form/BaseCheckbox.vue";
import BaseAlert from "../../component/element/BaseAlert.vue";
import serviceResponseHelper from "../../mixins/serviceResponseHelper";
import Vue from "vue";
import axios from "axios";
import MultiSelectWrapper from "../../component/element/form/select/MultiSelectWrapper.vue";
import { storeAuthTokens, clearAuthTokens } from "../../util/authTokenStorage";

export default {
  name: "LoginView",
  components: { MultiSelectWrapper, BaseAlert, BaseButton, BaseCheckBox },
  mixins: [serviceResponseHelper],
  data() {
    return {
      username: null,
      password: null,
      rememberMe: false,
      loading: false,
      shouldUserChooseUnit: false,
      // selectedUserUnit: null,
      userUnits: [],
      passwordType: "password",
      resetEnrollmentNo: null,
      loadingCheckOpenAccount: false,
      loadingAuthorizeByUnit: false,
      loadingResetPassword: false,
      loadingLoadSystemDateNow: false,
      loadingParametersByUnit: false,
    };
  },
  computed: {
    user: {
      get() {
        return this.$store.getters.getUser;
      },
      set(val) {
        this.$store.commit("setUser", val);
      },
    },
    loggedIn: {
      get() {
        return this.$store.getters.getLoggedIn;
      },
      set(val) {
        this.$store.commit("setLoggedIn", val);
      },
    },
    isOpenAccount: {
      get() {
        return this.$store.getters.getIsOpenAccount;
      },
      set(val) {
        this.$store.commit("setIsOpenAccount", val);
      },
    },
    autoCloseShown: {
      get() {
        return this.$store.getters.getAutoCloseShown;
      },
      set(val) {
        this.$store.commit("setAutoCloseShown", val);
      },
    },
    selectedUserUnitId: {
      get() {
        return this.$store.getters.getSelectedUserUnitId;
      },
      set(val) {
        this.$store.commit("setSelectedUserUnitId", val);
      },
    },
    loadingContinueButton() {
      return this.loadingAuthorizeByUnit || this.loadingCheckOpenAccount || this.loadingParametersByUnit;
    },
  },
  created() {
    if (this.$store.getters.getLoggedIn) {
      Vue.set(this, "shouldUserChooseUnit", true);
      this.userUnits = this.$store.getters.getUser.userUnits;
    }
    this.loadingLoadSystemDateNow = true;
    this.$store.dispatch("loadSystemDateNow").finally(() => {
      this.loadingLoadSystemDateNow = false;
    });
    if (!this.loggedIn) {
      this.$store.commit("setSelectedUserUnitId", null);
    }
    // else{
    //   this.$router.push("/sifre-sifirla");
    // }
  },
  mounted() {
    window.impersonateLogin = this.impersonateLogin;
  },
  methods: {
    login() {
      //localStorage için vuex store resetleme
      this.$store.commit("resetStore");

      // önceden login varsa temizle (login isteği TOKEN'SIZ gitsin diye)
      clearAuthTokens();
      //localStorage resetleme
      // for (let attr in localStorage){
      //   if (attr !== 'vuex') {
      //     localStorage.removeItem(attr);
      //   }
      // }

      let request = {};
      request.username = this.username;
      request.password = this.password;
      this.loading = true;
      this.$store
        .dispatch("userLogin", request)
        .then((response) => {
          this.loading = false;
          if (response.status === 500) {
            if (response.data.code === 600 || response.data.code === 604) {
              this.callAlert(4, response.data.message, "danger", "İşlem Hatası");
              return;
            }
            this.callAlert(4, "Lütfen kullanıcı adı ve şifrenizi kontrol ediniz.", "danger", "İşlem Hatası");
            return;
          }
          if (response.status === 400) {
            this.callAlert(4, response.data.message, "danger", "İşlem Hatası");
            return;
          }
          this.user = JSON.parse(JSON.stringify(response));
          storeAuthTokens(response);
          this.userUnits = response.userUnits;

          this.$nextTick(() => {
            Vue.set(this, "shouldUserChooseUnit", true);
            // başarısız bir alert almışsa ve 20 saniye içerisinde başarılı girmiş ise alerti sıfırla start
            this.resetAlertPage();
            // başarısız bir alert almışsa ve 20 saniye içerisinde başarılı girmiş ise alerti sıfırla end
            if (response.infoMessages && response.infoMessages.length > 0) {
              const messages = response.infoMessages.join(" ");
              this.callAlert(4, messages, "warning", "Uyarı!");
            }
          });
        })
        .catch((err) => {
          this.loading = false;
          this.callAlert(4, "İşlem gerçekleştirilememektedir.", "danger", "İşlem Hatası");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async goToSalesTransactions() {
      if (!this.selectedUserUnitId) {
        this.callAlert(4, "Lütfen birim seçiniz.", "danger", "Birim Seçiniz.", "danger");
        return;
      }

      this.loadingParametersByUnit = true;
      const request = this.userUnits.find((unit) => unit.id === this.selectedUserUnitId).id;
      this.$store
        .dispatch("parametersByUnit", request)
        .then((response) => {
          if (response.data.code === 0) {
            this.callAlert(4, response.data.message, "danger", "İşlem Hatası");
            this.resetUnitUser();
            return;
          } else {
            let maxPax = parseInt(response.data.maxPax);
            this.$store.commit("setParametersByUnit", maxPax);

            let checkOpenAccountRequest = {};
            checkOpenAccountRequest.salesUserId = this.user.userId;
            checkOpenAccountRequest.unitId = this.selectedUserUnitId;
            checkOpenAccountRequest.salesChannelId = this.userUnits.find((unit) => unit.id === this.selectedUserUnitId).salesChannel;
            this.loadingCheckOpenAccount = true;
            this.$store
              .dispatch("checkOpenAccount", checkOpenAccountRequest)
              .then((responseCheckOpenAccount) => {
                this.loadingCheckOpenAccount = false;
                this.isOpenAccount = responseCheckOpenAccount.data.openAccount;
                this.autoCloseShown = responseCheckOpenAccount.data.autoCloseShown;
                if (!this.autoCloseShown) {
                  this.$store.commit("setInformationForAutoClosePopUp", responseCheckOpenAccount.data);
                }
                if (this.isOpenAccount) {
                  this.selectedUserUnitId = responseCheckOpenAccount.data.unitId;
                  this.loggedIn = true;
                  this.$store.commit("setSelectedCloseUnit", this.selectedUserUnitId);
                } else {
                  this.$store.commit("setSelectedCloseUnit", null);
                }

                // localStorage.setItem("UNIT_ID", this.selectedUserUnit);
                axios.defaults.headers.common["unit-id"] = this.selectedUserUnitId;
                this.loggedIn = true;
                this.$store.commit("setLastActivityTime", new Date());
                let request = {};
                request.accessToken = localStorage.getItem("AUTH_TOKEN");
                request.unitId = this.selectedUserUnitId;
                this.loadingAuthorizeByUnit = true;
                this.$store
                  .dispatch("authorizeByUnit", request)
                  .then(async (response) => {
                    this.loadingAuthorizeByUnit = false;

                    this.$store.commit("setUserResources", response.resources);
                    this.$store.commit(
                      "setUserPermissions",
                      response.resources.map((resource) => resource.tag)
                    );
                    this.$store.commit("setAssociatedStationId", response.associatedStationId);
                    this.$store.dispatch("fetchStaffNotifications").catch(() => {});
                    if (this.isOpenAccount) {
                      this.$router.push("/personel-hesap-kapatma");
                    } else {
                      if (this.$route.path !== "/") {
                        this.$router.push("/");
                      }
                    }
                  })
                  .finally(() => {
                    this.loggedIn = true;
                    this.loadingLoadSystemDateNow = true;
                    this.$store.dispatch("loadSystemDateNow").finally(() => {
                      this.loadingLoadSystemDateNow = false;
                    });
                    this.loadingAuthorizeByUnit = false;
                  });
              })
              .finally(() => {
                this.loadingCheckOpenAccount = false;
              });
          }
          this.loadingParametersByUnit = false;
        })
        .catch(() => {
          this.callAlert(4, "İşlem Hatası", "danger", "İşlem Hatası");
          this.resetUnitUser();
        })
        .finally(() => {
          this.loadingParametersByUnit = false;
        });
    },
    impersonateLogin(userObject) {
      // önceden login varsa temizle (login isteği TOKEN'SIZ gitsin diye)
      clearAuthTokens();

      this.user = JSON.parse(JSON.stringify(userObject));
      storeAuthTokens(userObject);
      this.userUnits = userObject.userUnits;

      this.$nextTick(() => {
        Vue.set(this, "shouldUserChooseUnit", true);
        // başarısız bir alert almışsa ve 20 saniye içerisinde başarılı girmiş ise alerti sıfırla start
        this.resetAlertPage();
        // başarısız bir alert almışsa ve 20 saniye içerisinde başarılı girmiş ise alerti sıfırla end
      });
    },
    passwordShow(param) {
      if (param === "password") {
        this.passwordType = "text";
      } else if (param === "text") {
        this.passwordType = "password";
      }
    },
    resetPassword() {
      let resetPasswordReq = {};
      resetPasswordReq.username = this.resetEnrollmentNo;
      resetPasswordReq.sendCodeInEmail = false;
      this.loadingResetPassword = true;
      this.$store
        .dispatch("resetPasswordGenerateCode", resetPasswordReq)
        .then((restRes) => {
          if (restRes.status !== 200) {
            this.callAlert(4, "", "danger", "Beklenmeyen bir hata oluştu.", "danger");
            return;
          }
          this.callAlert(4, "E-posta adresinize doğrulama maili gönderildi.", "success", "Yeni şifre için kopyalayınız.", "success");
        })
        .finally(() => {
          this.loadingResetPassword = false;
        });
    },
    resetUnitUser() {
      this.shouldUserChooseUnit = !this.shouldUserChooseUnit;
      this.passwordType = "password";
      this.rememberMe = false;
      this.username = null;
      this.password = null;
      this.selectedUserUnitId = null;
      this.userUnits = [];
      this.resetEnrollmentNo = null;
      this.$store.commit("setSelectedUserUnitId", null);
    },
    requestPasswordReset() {
      window.open("https://parola.tcddtasimacilik.gov.tr/", "_blank");
      $("#passwordResetModal").modal("hide");
    },
    resetAlertPage() {
      this.$store.commit("setAlertText", "");
      this.$store.commit("setAlertTitle", "");
      this.$store.commit("setAlertVariant", "");
      this.$store.commit("setAlertIcon", "");
      this.$store.commit("setDismissCountDown", 0);
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  text-transform: none;
}

.ticketTypeModal .modal-dialog .modal-content .modal-header .modal-title img {
  padding: 4px;
}

.loginArea {
  background-image: url("../../../public/src/images/login-bg-2.png");
  background-position: bottom;

  .loginScreen {
    form {
      ::v-deep {
        .btn-secondary {
          @media (max-width: 575px) {
            font-size: 14px;
            padding: 13px 33px;
          }
        }
      }
    }
  }
}

.unitSelectArea {
  .form-group {
    flex-direction: column;
    margin-top: 0 !important;
  }
}
</style>
